<template>
	<widget title="Checklists" icon="fa-check-square">
		<checklist-table
			:hide-edit="false"
			:hide-delete="false"
			resource="Checklist"
			v-model="checklists">
		</checklist-table>
	</widget>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import ChecklistTable from "@/components/super_components/ChecklistTable"

export default {
	name: "ChecklistsManagerWidget",
	components: {
		Widget,
		ChecklistTable
	},
	props: [],
	data() {
		return {
			checklists: []
		}
	},
	computed: {

	},
	methods: {

		fetchChecklists() {
			let vm = this

			this.spinner(true)

			this.getJSON("Checklist/get").then(response => {
				vm.checklists = response.data
				vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchChecklists()
	}
}
</script>


